package tech.gensert.portal.web.showcase

import react.FC
import react.Props

val SettingsShowcase = FC<Props> {

}